import {
  ChefHat, Wine, UtensilsCrossed, Sparkles, Wallet, LayoutGrid, Crown,
  ClipboardList, BookOpen, History, FileText, Bot, AlertTriangle, BarChart3,
  LayoutDashboard, Users, Settings, Truck, Calendar, ShieldCheck,
  Package, Soup, Bell, Search, CheckSquare, Wrench, Thermometer, Megaphone, PieChart, Boxes, MonitorPlay,
} from "lucide-react";

const MAP = {
  ChefHat, Wine, UtensilsCrossed, Sparkles, Wallet, LayoutGrid, Crown,
  ClipboardList, BookOpen, History, FileText, Bot, AlertTriangle, BarChart3,
  LayoutDashboard, Users, Settings, Truck, Calendar, ShieldCheck,
  Package, Soup, Bell, Search, CheckSquare, Wrench, Thermometer, Megaphone, PieChart, Boxes, MonitorPlay,
};

export default function Icon({ name, className, strokeWidth = 1.75 }) {
  const Cmp = MAP[name] || LayoutGrid;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
}
